<template>
  <div>
  	<router-view></router-view>
  	<BottomSheet></BottomSheet>
  </div>
</template>

<script>
import BottomSheet from './BottomSheet'
import List from './instances/List'
import Editor from './instances/Editor'

export default {
	routes: [
		{
			path: "",
			redirect: "/instances/list"
		},
		{
			path: "list",
			component: List,
			name: "Instances list"
		},
		{
			path: "edit/:id",
			name: "Instance edit",
		  components: {
        default: List,
        bottomEditor: Editor
      },
      props: {
        default: false,
        bottomEditor: true
      },
		},
		{
			path: "new",
			name: "Instance new",
		  components: {
        default: List,
        bottomEditor: Editor
      },
      props: {
        default: false,
        bottomEditor: true
      },
      meta: {
        edit: "Instance edit"
      }
		}

	],
  components: {
  	BottomSheet
  }
}
</script>
